import React from "react";
import withIconComponent from "../withIconComponent";

var Document = function Document() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1v6h6z",
    "data-stroke": "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1v6h6",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    "data-cap": "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1H2v22h20V7z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7h4M7 12h10M7 17h10",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2",
    "data-color": "color-2"
  }));
};

export default withIconComponent("UiDocument", false)(Document);